<template>
    <div class="login-box">
        <div class="login-container">
            <div class="login-inner">
                <div class="login-right">
                    <div class="form-logo">
                        <img src="/static/logo.svg">
                    </div>
                    <div class="form-box">
                        <h3 class="form-title">{{$t('Fachstellen sign up')}}</h3>
                        <span class="line"></span>
                        <el-form label-position="top" :model="formData" ref="formData" :rules="rules">
                            <el-row :gutter="20">
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                    <el-form-item prop="display_name">
                                        <el-input placeholder="Name" v-model="formData.display_name"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                    <el-form-item prop="password" :rules="[{ required: true, message: $t('This field is required')},{ validator: validatePass, trigger: ['blur', 'change'] }]">
                                        <el-input placeholder="Passwort" type="password" v-model="formData.password"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                    <el-form-item prop="password_confirmation" :rules="[{ required: true, message: $t('This field is required')},{ validator: validatePass2, trigger: ['blur', 'change'] }]">
                                        <el-input placeholder="Passwort bestätigen" type="password" v-model="formData.password_confirmation"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                    <el-form-item prop="address" class="adr_input">
                                        <vue-google-autocomplete :country="['ch', 'so', 'iq']" v-model="formData.address"
                                            id="map" classname="el-input__inner" ref="address" placeholder="Adresse"
                                            v-on:placechanged="getAddressData" @change="handleAddressChange"></vue-google-autocomplete>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                    <el-form-item prop="place">
                                        <el-input placeholder="Platz" v-model="formData.place"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                    <el-form-item prop="zipcode">
                                        <el-input placeholder="Postleitzahl" v-model="formData.zipcode" @keyup.enter.native="validateBeforeSubmit('formData')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <input type="hidden" v-model="formData.latitude" name="latitude">
                                <input type="hidden" v-model="formData.longitude" name="longitude">
                            </el-row>
                            <el-form-item class="no-margin">
                                <el-button class="log-btn" type="primary" @click="submitForm('formData')">{{$t('Signup')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    @import "@/assets/sass/_login.scss";

</style>
<script>
    import VueGoogleAutocomplete from 'vue-google-autocomplete'
    export default {
        components: {
            VueGoogleAutocomplete
        },
        data() {
            return {
                formData: {
                    token: this.$route.params.token,
                    address: null,
                    place: null,
                    zipcode: null,
                    email: null,
                    display_name: null
                },
                fachstellenDetails: {},
                labelPosition: "top",
                validatePass: (rule, value, callback) => {
                    if (this.formData.password_confirmation !== '') {
                        this.$refs.formData.validateField('password_confirmation');
                    }
                    callback();
                },
                validatePass2: (rule, value, callback) => {
                    if (value !== this.formData.password) {
                        callback(new Error(this.$t('Password and password confirmation both should be match')));
                    } else {
                        callback();
                    }
                },
                rules: {
                    display_name: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    address: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: ['blur', 'change']
                    }],
                    place: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    zipcode: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }, {
                        pattern: /^[1-9]\d{3}$/, // /^[1-9]\d{3,4}$/,
                        trigger: ['blur', 'change'],
                        message: this.$t('Please enter valid zipcode'),
                        trigger: "blur"
                    }],
                }
            };
        },
        mounted() {
            request({
                    url: "fachstellen-signup/" + this.formData.token,
                    method: "get"
                })
                .then(response => {
                    this.fachstellenDetails = response.data.data;
                    if (this.fachstellenDetails) {
                        this.formData.email = this.fachstellenDetails.email;
                        this.formData.organization_slug = this.fachstellenDetails.organization_slug;
                        this.formData.fachstellen_type = this.fachstellenDetails.fachstellen_type;
                        this.formData.address = this.fachstellenDetails.address;
                        this.formData.place = this.fachstellenDetails.place;
                        this.formData.zipcode = this.fachstellenDetails.zipcode;
                        this.formData.display_name = this.fachstellenDetails.display_name;
                    }
                })
                .catch(error => {
                    this.$notify({
                        title: "Error",
                        message: error.response.data.message,
                        type: "error"
                    });
                });
        },
        methods: {
            handleAddressChange(address) {
                this.formData.address = address;
                this.$refs['formData'].validateField('address');
            },
            getAddressData: function (addressData, placeResultData, id) {
                this.formData.address = placeResultData.formatted_address;
                this.formData.place = placeResultData.vicinity;
                this.formData.zipcode = addressData.postal_code
                this.formData.latitude = addressData.latitude;
                this.formData.longitude = addressData.longitude;
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        request({
                                url: "fachstellen-signup-store/" + this.formData.token,
                                method: "PATCH",
                                data: this.formData
                            })
                            .then(response => {
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                                this.$refs[formName].resetFields();
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Auth/FachstellenSignup.vue